import { SvgIcon } from '@mui/material';
import colors from '../../../scss/colors';

function TickIcon({ color = colors.DARKEST_GREY, width = '26', height = '26' }) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d={`M10.3459 16.4125L19.5271 7.23125C19.7438 7.01458 20.0013 6.90625 20.2995 
        6.90625C20.5978 6.90625 20.8549 7.01458 21.0709 7.23125C21.2875 7.44792 21.3959 
        7.70539 21.3959 8.00367C21.3959 8.30194 21.2875 8.55906 21.0709 8.775L11.1042 
        18.7417C10.8875 18.9583 10.6348 19.0667 10.3459 19.0667C10.057 19.0667 9.8042 18.9583 
        9.58753 18.7417L4.9292 14.0833C4.71253 13.8667 4.60853 13.6092 4.6172 13.3109C4.62587 
        13.0126 4.73889 12.7555 4.95628 12.5396C5.17295 12.3229 5.43042 12.2146 5.7287 12.2146C6.02698 
        12.2146 6.28409 12.3229 6.50003 12.5396L10.3459 16.4125Z`}
        fill={color}
      />
    </SvgIcon>
  );
}

export default TickIcon;
